import React, { useState, useEffect } from "react";

import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { getModuleState } from "../../redux/reducers/ModuleStateReducer";

import OverviewStatus from "./OverviewStatus";
import { EOverviewModuleStatus } from "./OverviewStatus";
import ProgressStatusBar from "./ProgressStatusBar/ProgressStatusBar";

import { Module } from "../../Model/Module";
import { EModuleType } from "../../Model/EModuleType";
import {
  EImageProcessorState,
  ELimsConnectionStatus,
} from "../../Model/ModuleState";

type RipStatusProps = {
  module: Module;
};

const getModuleStatus = (ripStatus: EImageProcessorState) => {
  switch (ripStatus) {
    case EImageProcessorState.Idle:
    case EImageProcessorState.Started:
    case EImageProcessorState.Starting: {
      return EOverviewModuleStatus.Idle;
    }
    case EImageProcessorState.Busy: {
      return EOverviewModuleStatus.Busy;
    }
    default:
      return EOverviewModuleStatus.Error;
  }
};

export default function RipStatus({ module }: RipStatusProps) {
  const moduleState = useTypedSelector((state) =>
    getModuleState(state, module.identifier)
  );
  const ripStatus = moduleState?.imageProcessor;

  const moduleStatus = getModuleStatus(ripStatus?.state ?? 0);

  const freeSpace =
    ripStatus?.resourceStatus?.driveSpace?.availableFreeSpaceInByte ?? 0;
  const totalSpace =
    ripStatus?.resourceStatus?.driveSpace?.totalDriveSpaceInByte ?? 0;
  const freeSpaceInGb = (freeSpace / (1024 * 1024 * 1024)).toFixed(2) + " GB";
  const totalSpaceInGb = (totalSpace / (1024 * 1024 * 1024)).toFixed(2) + " GB";
  const occupiedSpaceinPercent =
    ((totalSpace - freeSpace) * 100.0) / totalSpace;

  const [limsConnectionText, setLimsConnectionText] = useState(
    ELimsConnectionStatus.Unknown.toString()
  );

  useEffect(() => {
    setLimsConnectionText(
      ripStatus?.limsConnectionStatus != null
        ? ELimsConnectionStatus[
            ripStatus.limsConnectionStatus.status
          ].toString()
        : ELimsConnectionStatus[ELimsConnectionStatus.Unknown].toString()
    );
  }, [ripStatus]);

  const limsText =
    freeSpace != null
      ? freeSpaceInGb + " free of " + totalSpaceInGb
      : "Unknown";

  const statusses = {
    "Database [Lims]": limsConnectionText,
    Status: EImageProcessorState[ripStatus?.state ?? 0],
    "Installed on": ripStatus?.machineName,
    LIMS: limsText,
    ...(freeSpace != null
      ? {
          hide_lims: (
            <ProgressStatusBar
              value={occupiedSpaceinPercent ?? 0}
              style={{ width: "86%" }}
            />
          ),
        }
      : {}),
  };

  return (
    <OverviewStatus
      moduleType={EModuleType.RIP}
      name={"ROCK IMAGER PROCESSOR"}
      statusses={statusses}
      moduleStatus={moduleStatus}
    />
  );
}
